"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9142],{

/***/ 9142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v5_Services; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./src/i18n.ts + 5 modules
var src_i18n = __webpack_require__(76361);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./src/constants/ServicesConstants.tsx
var ServicesConstants = __webpack_require__(89625);
// EXTERNAL MODULE: ./src/store/index.ts + 6 modules
var store = __webpack_require__(40367);
// EXTERNAL MODULE: ./src/useV5ImgSrc.tsx
var useV5ImgSrc = __webpack_require__(52299);
// EXTERNAL MODULE: ./src/components/_common/_constants.ts + 1 modules
var _constants = __webpack_require__(93932);
// EXTERNAL MODULE: ./src/components/_common/Carbon.tsx
var Carbon = __webpack_require__(29946);
// EXTERNAL MODULE: ./src/components/_common/LazyComp.tsx
var LazyComp = __webpack_require__(90008);
// EXTERNAL MODULE: ./src/components/v5/V5Comp.tsx
var V5Comp = __webpack_require__(63575);
;// CONCATENATED MODULE: ./src/components/v5/MobileServiceCards.tsx
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */ 



const MobileServiceCards = (param)=>{
    let { modes  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "bg-gray50 hide-scroll-bars",
        "aria-labelledby": "services-heading",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                id: "services-heading",
                className: "visually-hidden",
                children: i18n.t("Services")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "dg pos-r pv14 pl3 pr3 ovf-x-a ovf-y-h",
                children: modes.map((mode)=>{
                    var _mode_buttons_, _mode_buttons_1, _mode_commonReasons;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                        className: "df fdc tac br5 mr3 bs2 hfc oh w16rem",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "df fdc pt7 mb1 ph7 aic",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "font-csb fs22 mb3 wsnw",
                                        style: {
                                            letterSpacing: 0.25
                                        },
                                        tabIndex: 0,
                                        children: mode.header
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        className: "font-im fs12 mb4 wsnw",
                                        children: mode.subtext
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                                        className: "pos-r mb8",
                                        fontSize: 0.75,
                                        ...mode.buttons[0]
                                    }),
                                    mode.buttons[1] && /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                                        // @ts-expect-error TS2532: Object is possibly 'undefined'.
                                        href: ((_mode_buttons_ = mode.buttons[1]) === null || _mode_buttons_ === void 0 ? void 0 : _mode_buttons_.href) || "#learn-more",
                                        bg: "transparent",
                                        className: "font-ib fs12",
                                        // @ts-expect-error TS2532: Object is possibly 'undefined'.
                                        color: ((_mode_buttons_1 = mode.buttons[0]) === null || _mode_buttons_1 === void 0 ? void 0 : _mode_buttons_1.bg) || mode.panelColor,
                                        fontSize: 0.75,
                                        // @ts-expect-error TS2532: Object is possibly 'undefined'.
                                        "aria-label": mode.buttons[1]["aria-label"],
                                        children: i18n.t("Learn More")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "dg gafr gtc2a gg3 white fs13 font-im p3 aic",
                                style: {
                                    backgroundColor: mode.panelColor,
                                    color: mode.listColor
                                },
                                children: (_mode_commonReasons = mode.commonReasons) === null || _mode_commonReasons === void 0 ? void 0 : _mode_commonReasons.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "",
                                        children: item
                                    }, "common-reason-".concat(i)))
                            })
                        ]
                    }, "mobile-service-card-".concat(mode.header));
                }).append(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "ph1"
                }, "spacer"))
            })
        ]
    });
};
/* harmony default export */ var v5_MobileServiceCards = (MobileServiceCards);

;// CONCATENATED MODULE: ./src/components/v5/Services.tsx


/* eslint-disable jsx-a11y/no-noninteractive-tabindex */ 








const Services = (param)=>{
    let { modes  } = param;
    var _activeMode_commonReasons;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { modes: innerModes  } = (0,ServicesConstants/* default */.Z)({});
    if (!modes) {
        modes = innerModes;
    }
    const { width  } = (0,Carbon/* useWindowSize */.fy)();
    const { isMobile  } = (0,store/* useTypedSelector */.ix)((state)=>state.config);
    const [activeIndex, setActiveIndex] = (0,react.useState)(0);
    const activeMode = modes[activeIndex];
    const toggleIndex = (i)=>()=>{
            setActiveIndex(i);
        };
    const imgSrc = (0,useV5ImgSrc/* useV5ImgSrc */.eH)((activeMode === null || activeMode === void 0 ? void 0 : activeMode.bgImage) || "");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v5_MobileServiceCards, {
            modes: modes
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: "df pr3 fdcr-sm contrast-tbt",
            "aria-labelledby": "services-heading",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    id: "services-heading",
                    className: "visually-hidden",
                    children: i18n.t("Services")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    "aria-hidden": true,
                    className: "fx2 fx3-md p4 pl8 pl2-sm df fdc fs60 fs50-xl fs48-lg fs38-md font-csb lh15 t-200 oh dn-sm contrast-tbr",
                    style: {
                        ...activeMode.bgImage ? {
                            backgroundImage: "url(".concat(imgSrc, ")")
                        } : {},
                        backgroundSize: "cover",
                        backgroundRepeat: "none",
                        backgroundColor: activeMode.panelColor,
                        color: activeMode.listColor,
                        letterSpacing: -1
                    },
                    children: (_activeMode_commonReasons = activeMode.commonReasons) === null || _activeMode_commonReasons === void 0 ? void 0 : _activeMode_commonReasons.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "wsnw",
                            children: item
                        }, "common-reason-".concat(i)))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "fx3 bg-gray50",
                    style: {
                        paddingTop: 100 - modes.length * 20
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pt36 pt16-xl pt14-lg pb4-sm pl20 pl16-xl pl10-lg pl6-md pl3-sm t-200 minh140-sm w100p",
                        children: modes.map((mode, i)=>{
                            var _mode_commonReasons;
                            const isActive = i === activeIndex;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mb16 mb10-md mb6-sm df",
                                onMouseEnter: toggleIndex(i),
                                onFocus: toggleIndex(i),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "br5 t-200 mr8 mr4-md mt3 mt2-lg",
                                        style: {
                                            height: 20,
                                            width: 20,
                                            backgroundColor: mode.dotColor || mode.panelColor,
                                            opacity: isActive ? 1 : 0
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: "fs36 fs30-lg mb1",
                                                tabIndex: 0,
                                                children: mode.header
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "t-200",
                                                style: {
                                                    // @ts-expect-error TS2532: Object is possibly 'undefined'.
                                                    height: isActive ? width < 752 ? "9.5rem" : "8rem" : 0,
                                                    opacity: isActive ? 1 : 0
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        className: "dib font-ir mb4 mb2-sm",
                                                        children: mode.subtext
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                        className: "visually-hidden",
                                                        children: (_mode_commonReasons = mode.commonReasons) === null || _mode_commonReasons === void 0 ? void 0 : _mode_commonReasons.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: item
                                                            }, "common-reason-".concat(i)))
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "df fdc-sm",
                                                        children: mode.buttons.map((props, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                                                                className: "pos-r mr2 mr0-sm mb6-sm fs14-f fs12-f-sm",
                                                                ...props
                                                            }, "".concat(props.href).concat(i)))
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, mode.header);
                        })
                    })
                })
            ]
        })
    });
};
const ServicesWrapper = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(LazyComp/* LazyComp */.P, {
        visibleByDefault: Boolean(_constants/* isCI */.yg),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Services, {
            ...props
        })
    });
/* harmony default export */ var v5_Services = (ServicesWrapper);


/***/ }),

/***/ 89625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _c10h_colors__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(45602);
/* harmony import */ var _components_ReadableSlotTime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(566);
/* harmony import */ var color__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(32130);
/* harmony import */ var color__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(color__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var ni18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76361);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32466);
/* harmony import */ var src_components_common_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93932);
/* harmony import */ var src_constants_specialtyIds__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93209);
/* harmony import */ var _components_common_Carbon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29946);
/* harmony import */ var _hooks_useGetSoonestTime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46102);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40367);
/* harmony import */ var _utils_getRedirectUrl__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34488);
/* harmony import */ var _practiceIds__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34557);



// @ts-expect-error TS7016: Could not find a declaration file for module 'color'. '/Users/goksel/Sites/carbon-website-next/node_modules/color/index.js' implicitly has an 'any' type.










const useServicesConstants = (param)=>{
    let { practiceId =_practiceIds__WEBPACK_IMPORTED_MODULE_10__/* .PracticeId.CARBON */ .I.CARBON  } = param;
    var _locations_findById, _locations_findById_region, _locations_findById1, _locations_findById_region1;
    const i18n = (0,ni18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)();
    const { locations  } = (0,_store__WEBPACK_IMPORTED_MODULE_8__/* .useTypedSelector */ .ix)((param)=>{
        let { config  } = param;
        return config;
    });
    const primaryCareSlot = (0,_hooks_useGetSoonestTime__WEBPACK_IMPORTED_MODULE_7__/* .useGetSoonestInPracticeBySpecialtyId */ .zn)({
        specialtyId: src_constants_specialtyIds__WEBPACK_IMPORTED_MODULE_5__/* .SpecialtyId.PRIMARY_CARE */ .mg.PRIMARY_CARE
    });
    const urgentCareSlot = (0,_hooks_useGetSoonestTime__WEBPACK_IMPORTED_MODULE_7__/* .useGetSoonestInPracticeBySpecialtyId */ .zn)({
        specialtyId: src_constants_specialtyIds__WEBPACK_IMPORTED_MODULE_5__/* .SpecialtyId.URGENT_CARE */ .mg.URGENT_CARE
    });
    const virtualMentalSlot = (0,_hooks_useGetSoonestTime__WEBPACK_IMPORTED_MODULE_7__/* .useGetSoonestInPracticeBySpecialtyId */ .zn)({
        specialtyId: src_constants_specialtyIds__WEBPACK_IMPORTED_MODULE_5__/* .SpecialtyId.VIRTUAL_MENTAL_HEALTH */ .mg.VIRTUAL_MENTAL_HEALTH
    });
    const virtualPCSlot = (0,_hooks_useGetSoonestTime__WEBPACK_IMPORTED_MODULE_7__/* .useGetSoonestInPracticeBySpecialtyId */ .zn)({
        specialtyId: src_constants_specialtyIds__WEBPACK_IMPORTED_MODULE_5__/* .SpecialtyId.VIRTUAL_PRIMARY_CARE */ .mg.VIRTUAL_PRIMARY_CARE
    });
    const primaryCareSlotRegionSlug = (_locations_findById = locations.findById((primaryCareSlot === null || primaryCareSlot === void 0 ? void 0 : primaryCareSlot.locationId) || "")) === null || _locations_findById === void 0 ? void 0 : (_locations_findById_region = _locations_findById.region) === null || _locations_findById_region === void 0 ? void 0 : _locations_findById_region.slug;
    const urgentCareSlotRegionSlug = (_locations_findById1 = locations.findById((urgentCareSlot === null || urgentCareSlot === void 0 ? void 0 : urgentCareSlot.locationId) || "")) === null || _locations_findById1 === void 0 ? void 0 : (_locations_findById_region1 = _locations_findById1.region) === null || _locations_findById_region1 === void 0 ? void 0 : _locations_findById_region1.slug;
    const learnMoreBtnProps = {
        href: "#featured-locations",
        children: i18n.t("Learn More"),
        className: "pos-r mr2 p4 mr0-sm mb6-sm fs14-f fs12-f-sm brd2nc-f brd-black-f black-f bg-gray50-f"
    };
    const getNextApptSlot = (keyPrefix, nextSlot)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            className: "pos-a font-im gray800 fs12 left0 right0 ma empty:hidden",
            style: {
                bottom: -20
            },
            children: [
                i18n.t("Next: "),
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ReadableSlotTime__WEBPACK_IMPORTED_MODULE_1__/* .ReadableSlotTime */ .n, {
                    time: nextSlot
                })
            ]
        }, "services-next-appt-".concat(keyPrefix));
    const modes = [
        {
            header: i18n.t("Primary Care"),
            subtext: i18n.t("Ideal for preventative care"),
            buttons: [
                {
                    bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_11__.darkerBlue,
                    hoverBg: _c10h_colors__WEBPACK_IMPORTED_MODULE_11__.darkBlue,
                    href: "".concat(src_components_common_constants__WEBPACK_IMPORTED_MODULE_4__/* .v5Pages.locations */ .Td.locations, "?specialtyId=").concat(src_constants_specialtyIds__WEBPACK_IMPORTED_MODULE_5__/* .SpecialtyId.PRIMARY_CARE */ .mg.PRIMARY_CARE, "&regionSlug=").concat(primaryCareSlotRegionSlug),
                    children: [
                        i18n.t("Book an Appointment"),
                        getNextApptSlot("primary-care", primaryCareSlot === null || primaryCareSlot === void 0 ? void 0 : primaryCareSlot.time)
                    ],
                    "aria-label": i18n.t("Book an Appointment for {{specialtyName}}. Next Available: {{slotTime}}", {
                        specialtyName: i18n.t("Primary Care"),
                        slotTime: (0,_components_common_Carbon__WEBPACK_IMPORTED_MODULE_6__/* .todayTomorrow2 */ .mE)(i18n.lang, primaryCareSlot === null || primaryCareSlot === void 0 ? void 0 : primaryCareSlot.time)
                    })
                },
                {
                    ...learnMoreBtnProps,
                    href: "/get-care/primary-care",
                    "aria-label": i18n.t("Learn more about {{specialtyName}}", {
                        specialtyName: i18n.t("Primary Care")
                    })
                }
            ],
            panelColor: _c10h_colors__WEBPACK_IMPORTED_MODULE_11__.blue,
            dotColor: _c10h_colors__WEBPACK_IMPORTED_MODULE_11__.darkerBlue,
            listColor: color__WEBPACK_IMPORTED_MODULE_12___default()(_c10h_colors__WEBPACK_IMPORTED_MODULE_11__.darkerBlue).alpha(0.75),
            commonReasons: [
                i18n.t("Allergy Symptoms"),
                i18n.t("Back Pain"),
                i18n.t("Cold or Flu"),
                i18n.t("Red Eye"),
                i18n.t("Birth Control"),
                i18n.t("Hypertension"),
                i18n.t("Specialist Referral"),
                i18n.t("Diabetes"),
                i18n.t("Medication Refill"),
                i18n.t("Skin Rash"),
                i18n.t("Annual Physical")
            ]
        },
        {
            header: i18n.t("Urgent Care"),
            subtext: i18n.t("Ideal for immediate needs"),
            buttons: [
                {
                    bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_11__.darkerYellow,
                    hoverBg: _c10h_colors__WEBPACK_IMPORTED_MODULE_11__.darkYellow,
                    href: "".concat(src_components_common_constants__WEBPACK_IMPORTED_MODULE_4__/* .v5Pages.locations */ .Td.locations, "?specialtyId=").concat(src_constants_specialtyIds__WEBPACK_IMPORTED_MODULE_5__/* .SpecialtyId.URGENT_CARE */ .mg.URGENT_CARE, "&regionSlug=").concat(urgentCareSlotRegionSlug),
                    children: [
                        i18n.t("Book an Appointment"),
                        getNextApptSlot("urgent-care", urgentCareSlot === null || urgentCareSlot === void 0 ? void 0 : urgentCareSlot.time)
                    ],
                    "aria-label": i18n.t("Book an Appointment for {{specialtyName}}. Next Available: {{slotTime}}", {
                        specialtyName: i18n.t("Urgent Care"),
                        slotTime: (0,_components_common_Carbon__WEBPACK_IMPORTED_MODULE_6__/* .todayTomorrow2 */ .mE)(i18n.lang, urgentCareSlot === null || urgentCareSlot === void 0 ? void 0 : urgentCareSlot.time)
                    })
                },
                {
                    ...learnMoreBtnProps,
                    href: "/get-care/urgent-care",
                    "aria-label": i18n.t("Learn more about {{specialtyName}}", {
                        specialtyName: i18n.t("Urgent Care")
                    })
                }
            ],
            panelColor: _c10h_colors__WEBPACK_IMPORTED_MODULE_11__.lightYellow,
            dotColor: _c10h_colors__WEBPACK_IMPORTED_MODULE_11__.darkerYellow,
            listColor: color__WEBPACK_IMPORTED_MODULE_12___default()(_c10h_colors__WEBPACK_IMPORTED_MODULE_11__.darkerYellow).alpha(0.75),
            commonReasons: [
                i18n.t("UTI"),
                i18n.t("Headache"),
                i18n.t("Injuries"),
                i18n.t("Cuts"),
                i18n.t("STI"),
                i18n.t("Rash"),
                i18n.t("Cough"),
                i18n.t("Cold or Flu"),
                i18n.t("Fever"),
                i18n.t("Stomach Pain"),
                i18n.t("Red Eye")
            ]
        },
        {
            header: i18n.t("Mental Health"),
            subtext: i18n.t("Video call with a provider"),
            buttons: [
                {
                    bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_11__.darkerPurple,
                    hoverBg: _c10h_colors__WEBPACK_IMPORTED_MODULE_11__.darkPurple,
                    href: (0,_utils_getRedirectUrl__WEBPACK_IMPORTED_MODULE_9__/* .getSchedulingRedirectUrl */ ._W)({
                        practiceId,
                        specialtyId: src_constants_specialtyIds__WEBPACK_IMPORTED_MODULE_5__/* .SpecialtyId.VIRTUAL_MENTAL_HEALTH */ .mg.VIRTUAL_MENTAL_HEALTH,
                        virtual: true
                    }),
                    children: [
                        i18n.t("Book an Appointment"),
                        getNextApptSlot("mental-health", virtualMentalSlot === null || virtualMentalSlot === void 0 ? void 0 : virtualMentalSlot.time)
                    ],
                    "aria-label": i18n.t("Book an Appointment for {{specialtyName}}. Next Available: {{slotTime}}", {
                        specialtyName: i18n.t("Mental Health"),
                        slotTime: (0,_components_common_Carbon__WEBPACK_IMPORTED_MODULE_6__/* .todayTomorrow2 */ .mE)(i18n.lang, virtualMentalSlot === null || virtualMentalSlot === void 0 ? void 0 : virtualMentalSlot.time)
                    })
                },
                {
                    ...learnMoreBtnProps,
                    href: "/virtual-care-mental",
                    "aria-label": i18n.t("Learn more about {{specialtyName}}", {
                        specialtyName: i18n.t("Mental Health")
                    })
                }
            ],
            dotColor: _c10h_colors__WEBPACK_IMPORTED_MODULE_11__.darkerPurple,
            panelColor: _c10h_colors__WEBPACK_IMPORTED_MODULE_11__.lightPurple,
            listColor: color__WEBPACK_IMPORTED_MODULE_12___default()(_c10h_colors__WEBPACK_IMPORTED_MODULE_11__.darkerPurple).alpha(0.6),
            commonReasons: [
                i18n.t("Anxiety"),
                i18n.t("Depression"),
                i18n.t("Smoking Cessation"),
                i18n.t("Alcohol Use"),
                i18n.t("Weight Loss"),
                i18n.t("Stress"),
                i18n.t("Family Therapy"),
                i18n.t("ADHD"),
                i18n.t("Sadness"),
                i18n.t("Relationships"),
                i18n.t("Group Therapy")
            ]
        },
        {
            header: i18n.t("Women's Health"),
            subtext: i18n.t("Women's health and wellness"),
            buttons: [
                {
                    bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_11__.darkerMint,
                    hoverBg: _c10h_colors__WEBPACK_IMPORTED_MODULE_11__.darkMint,
                    href: (0,_utils_getRedirectUrl__WEBPACK_IMPORTED_MODULE_9__/* .getSchedulingRedirectUrl */ ._W)({
                        practiceId,
                        specialtyId: src_constants_specialtyIds__WEBPACK_IMPORTED_MODULE_5__/* .SpecialtyId.VIRTUAL_PRIMARY_CARE */ .mg.VIRTUAL_PRIMARY_CARE
                    }),
                    children: [
                        i18n.t("Book an Appointment"),
                        getNextApptSlot("womens-health", virtualPCSlot === null || virtualPCSlot === void 0 ? void 0 : virtualPCSlot.time)
                    ],
                    "aria-label": i18n.t("Book an Appointment for {{specialtyName}}. Next Available: {{slotTime}}", {
                        specialtyName: i18n.t("Women's Health"),
                        slotTime: (0,_components_common_Carbon__WEBPACK_IMPORTED_MODULE_6__/* .todayTomorrow2 */ .mE)(i18n.lang, virtualPCSlot === null || virtualPCSlot === void 0 ? void 0 : virtualPCSlot.time)
                    })
                },
                {
                    ...learnMoreBtnProps,
                    href: src_components_common_constants__WEBPACK_IMPORTED_MODULE_4__/* .v5Pages.womensHealth */ .Td.womensHealth,
                    "aria-label": i18n.t("Learn more about {{specialtyName}}", {
                        specialtyName: i18n.t("Women's Health")
                    })
                }
            ],
            dotColor: _c10h_colors__WEBPACK_IMPORTED_MODULE_11__.darkerMint,
            panelColor: _c10h_colors__WEBPACK_IMPORTED_MODULE_11__.darkGreen,
            listColor: color__WEBPACK_IMPORTED_MODULE_12___default()(_c10h_colors__WEBPACK_IMPORTED_MODULE_11__.lightMint).alpha(0.7),
            commonReasons: [
                i18n.t("UTI"),
                i18n.t("Breast Health"),
                i18n.t("Annual Physical"),
                i18n.t("Pelvic Exam"),
                i18n.t("Pap Smear"),
                i18n.t("Bone Density Exam"),
                i18n.t("Ultrasound"),
                i18n.t("Birth Control"),
                i18n.t("Skin Cancer"),
                i18n.t("Pregnancy Test"),
                i18n.t("Vaginal Infection")
            ]
        },
        {
            header: i18n.t("LGBTQ+ Health"),
            subtext: i18n.t("Inclusive + judgment-free"),
            buttons: [
                {
                    bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_11__.darkerPurple,
                    hoverBg: _c10h_colors__WEBPACK_IMPORTED_MODULE_11__.darkPurple,
                    href: (0,_utils_getRedirectUrl__WEBPACK_IMPORTED_MODULE_9__/* .getSchedulingRedirectUrl */ ._W)({
                        practiceId,
                        specialtyId: src_constants_specialtyIds__WEBPACK_IMPORTED_MODULE_5__/* .SpecialtyId.VIRTUAL_PRIMARY_CARE */ .mg.VIRTUAL_PRIMARY_CARE
                    }),
                    children: [
                        i18n.t("Book an Appointment"),
                        getNextApptSlot("lgbtq", virtualPCSlot === null || virtualPCSlot === void 0 ? void 0 : virtualPCSlot.time)
                    ],
                    "aria-label": i18n.t("Book an Appointment for {{specialtyName}}. Next Available: {{slotTime}}", {
                        specialtyName: i18n.t("LGBTQ+ Health"),
                        slotTime: (0,_components_common_Carbon__WEBPACK_IMPORTED_MODULE_6__/* .todayTomorrow2 */ .mE)(i18n.lang, virtualPCSlot === null || virtualPCSlot === void 0 ? void 0 : virtualPCSlot.time)
                    })
                },
                {
                    ...learnMoreBtnProps,
                    href: src_components_common_constants__WEBPACK_IMPORTED_MODULE_4__/* .v5Pages.lgbtq */ .Td.lgbtq,
                    "aria-label": i18n.t("Learn more about {{specialtyName}}", {
                        specialtyName: i18n.t("LGBTQ+ Health")
                    })
                }
            ],
            dotColor: _c10h_colors__WEBPACK_IMPORTED_MODULE_11__.darkerPurple,
            panelColor: _c10h_colors__WEBPACK_IMPORTED_MODULE_11__.lighterPurple,
            commonReasons: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "darkerRed",
                    children: i18n.t("Annual Physical")
                }, "r1"),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "red",
                    children: i18n.t("Pelvic Exam")
                }, "r2"),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "red",
                    children: i18n.t("Chest Health")
                }, "r3"),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "darkerYellow",
                    children: i18n.t("STI/HIV")
                }, "r4"),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "darkerYellow",
                    children: i18n.t("Cancer Screening")
                }, "r5"),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "darkerMint",
                    children: i18n.t("Ultrasound")
                }, "r6"),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "darkerMint",
                    children: i18n.t("Depression")
                }, "r7"),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "darkerBlue",
                    children: i18n.t("Anxiety")
                }, "r8"),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "darkerBlue",
                    children: i18n.t("Pap Smear")
                }, "r9"),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "darkerPurple",
                    children: i18n.t("Behavioral Health")
                }, "r10"),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "darkerPurple",
                    children: i18n.t("UTI")
                }, "r11")
            ]
        }
    ];
    return {
        modes
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useServicesConstants);


/***/ })

}]);